module.exports = __webpack_public_path__ + "img/resource-img1.086eb27e.jpg";